import type { IconSvgObject } from './types';

const NavigationIcon: IconSvgObject = [
  ["path", { d: "M14.1758 20.5731L20.9371 4.15271C20.9786 4.05188 21 3.94389 21 3.83485C21 3.37378 20.6262 3 20.1651 3C20.0561 3 19.9481 3.02137 19.8473 3.06289L3.42691 9.8246C3.16859 9.93097 3 10.1827 3 10.4621C3 10.7785 3.21532 11.0542 3.52224 11.1309L11 13L12.8694 20.4778C12.9462 20.7847 13.2219 21 13.5383 21C13.8176 21 14.0694 20.8314 14.1758 20.5731Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default NavigationIcon;
